export function filterAnalytics(rows, { employees = [], categories = [], from, to } = {}) {
    return rows.filter(row => (!employees.length || employees.includes(String(row.employee_id)))
        && (!categories.length || categories.includes(row.category))
        && (!from || (row.order_date && row.order_date >= from))
        && (!to || (row.order_date && row.order_date <= to)));
}
export function summarizeAnalytics(rows) {
    return { orders: new Set(rows.map(row => row.order_id)).size,
        lines: rows.reduce((sum, row) => sum + Number(row.line_count || 0), 0),
        quantity: rows.reduce((sum, row) => sum + Number(row.quantity || 0), 0) };
}
export function groupAnalytics(rows, field) {
    const groups = new Map();
    rows.forEach(row => {
        const key = String(row[field]);
        if (!groups.has(key)) groups.set(key, []);
        groups.get(key).push(row);
    });
    return [...groups].map(([key, items]) => ({ key, name: field === "employee_id" ? items[0].employee_name : key, ...summarizeAnalytics(items) }));
}
